export default __webpack_public_path__ + "static/media/ekidd2.df362ca8.jpeg";